export default __webpack_public_path__ + "static/media/rocket.036ed5be.svg";